<template>
    <div>
        <div class="bg">
            <div class="lockTxt"></div>
            <div class="close" @click="centerDialogVisible=true"></div>
        </div>
         <el-dialog
            title="提示"
            :visible.sync="centerDialogVisible"
            :width="dialogWidth"
            center>
            <span>是否确定退出登录</span>
            <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="outLogins()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                centerDialogVisible:false,
                dialogWidth:'30%',
            }
        },
        methods:{
            outLogins(){
                this.$store.commit('user/outLogin');
                this.$message({
                    message :"退出成功",
                    type:'success'
                });
            }
        },
         created(){
            if(this.$IsPc()){
                this.dialogWidth = "80%";
            };
        },
    }
</script>

<style scoped>
    .bg{
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: url(../../../assets/images/common/lockingBg.png) no-repeat center;
    }
    .bg .lockTxt{
        width: 45%;
        height:50%;
        background:url(../../../assets/images/common/lockingTxt.png) no-repeat center;
        background-size: 100%;
        position: absolute;
        left:50%;
        top: 50%;
        transform: translate(-50%,-50%);
    }
    .bg .close{
        height:100px;
        width:100px;
        position: absolute;
        top:25%;
        left:64%;
        cursor: pointer;
    }
    @media screen and (max-width: 768px) {
        .bg .lockTxt{
            width: 95%;
            height:50%;
        }
         .bg .close{
            height:50px;
            width:50px;
            position: absolute;
            top:34%;
            left:80%;
            cursor: pointer;
        }
    }
</style>
